import React from 'react';
import { Col, Row } from 'reactstrap';
import uniqueId from 'lodash/uniqueId';
import SkeletonElement from './SkeletonElement';

const ARTICLES_COUNT = 4;
const ICON_SIZE = 20;
const IMAGE_SIZE = 95;

const ArticlesPreviewSkeleton = () => {
  const imageStyle = { width: IMAGE_SIZE, height: IMAGE_SIZE };
  const iconStyle = { width: ICON_SIZE, height: ICON_SIZE };

  const articlesPreview = [...Array(ARTICLES_COUNT)].map(() => (
    <div className="articles-preview-article border-bottom" key={uniqueId()}>
      <div className="p-0">
        <SkeletonElement type="image" style={imageStyle} />
      </div>
      <div className="flex-grow-1">
        <Row className="h-100 justify-content-between gap-3 m-0">
          <Col xs={12} className="ps-3">
            <Row className="justify-content-between flex-wrap">
              <Col xs={10}>
                <SkeletonElement type="label" />
              </Col>
              <Col xs={2} className="trash-icon-container d-flex justify-content-end px-0">
                <SkeletonElement type="label" className="" style={iconStyle} />
              </Col>
              <Col xs={12}>
                <SkeletonElement type="label-short" className="my-0" />
              </Col>
            </Row>
          </Col>
          <Col xs={12} className="ps-3 mt-auto">
            <Row className="align-items-end justify-content-between">
              <Col>
                <SkeletonElement type="label" />
              </Col>
              <Col className="d-flex justify-content-end px-0">
                <SkeletonElement type="label" />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  ));

  return (
    <div className="articles-preview-list">
      {articlesPreview}
      <div className="d-flex justify-content-between pt-4 px-sm-0 align-items-baseline">
        <SkeletonElement type="label-short" />
        <SkeletonElement type="label-short" />
      </div>
    </div>
  );
};

export default ArticlesPreviewSkeleton;
